import { INewReviewReducerState } from '../../reducers/newReview';
import {
  ECleaning,
  EComfortAndAppliance,
  ELocation,
  EOverallScore,
  EPolite,
  EPriceAndQuality,
  IRating,
} from '../../repositories/dailyrent/entities/rating/Rating';

function mapScoreToRequestRating(
  score: number,
): EOverallScore | ECleaning | EComfortAndAppliance | ELocation | EPolite | EPriceAndQuality | undefined {
  return [undefined, EOverallScore.One, EOverallScore.Two, EOverallScore.Three, EOverallScore.Four, EOverallScore.Five][
    score
  ];
}

export function mapFormRatingToRating(rating: INewReviewReducerState['data']): IRating {
  return {
    overallScore: mapScoreToRequestRating(rating.overallScore) as EOverallScore,
    polite: mapScoreToRequestRating(rating.polite) as EPolite | null,
    priceAndQuality: mapScoreToRequestRating(rating.priceAndQuality) as EPriceAndQuality | null,
    location: mapScoreToRequestRating(rating.location) as ELocation | null,
    comfortAndAppliance: mapScoreToRequestRating(rating.comfortAndAppliance) as EComfortAndAppliance | null,
    cleaning: mapScoreToRequestRating(rating.cleaning) as ECleaning | null,
  };
}

// Deprecated: use mapFormRatingToRating instead
export function mapFormRatingToRatingSchema(rating: INewReviewReducerState['data']): IRating {
  return mapFormRatingToRating(rating);
}
